module.exports = __webpack_public_path__ + "static/headshot-chris-long.bcc5e52f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-chris-long.jpg
// module id = 122
// module chunks = 35783957827783 152909308826437